import React, { useContext, useEffect } from 'react';
import { Grid } from '@mui/material';
import useFilterCtx from "./filterpanel/useFilterCtx";
import { TableContainer } from '@mui/material';
import { Table } from '@mui/material';
import { TableBody } from '@mui/material';
import { TableHead } from '@mui/material';
import Reportingzeile from './Reportingzeile';
import { Paper } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { TableCell } from '@mui/material';
import { TableSortLabel } from '@mui/material';
import { Box } from "@mui/material";
/*
import { IconButton } from "@mui/material";
import { useTheme } from "@mui/material";
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
*/
import { visuallyHidden } from '@mui/utils';
import { TableRow } from '@mui/material';
import { Snackbar } from '@mui/material';
import { Alert } from '@mui/material';
import { Typography } from '@mui/material';
import { HeadCells } from './TableHeaderDefinitions';
import { CustomerDataContext } from '../context/CustomerDataProvider';
import { CustomerHistory } from '../../types/apimodel';


interface ReportGridProperties {

}
/*
interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number,
  ) => void;
}
*/
/*
function TablePaginationActions(props: TablePaginationActionsProps) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (

    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}
*/


export default function ReportGrid(props: ReportGridProperties) {
  // const [dataCount, setDataCount] = useState<number>(0);
  const { filterChanged, resetFilterChanged, reload, fireReload, sortOrder, setSortOrder, orderBy, setOrderBy } = useFilterCtx();
  const { tenant, reportData, loading, error, resetError } = useContext(CustomerDataContext);
  console.log("Cusomter history data", reportData);

  // const [page, setPage] = React.useState(0);
  //const [rowsPerPage, setRowsPerPage] = React.useState(10);



  const resetPaging = () => {
    // setPage(0);
  }


  useEffect(() => {
    // setDataCount(0);
    // let filterPage:number = page;
    if (filterChanged === true) {
      // filterPage = 0;
      resetPaging();
      resetFilterChanged();
    }
    // eslint-disable-next-line

  }, [reload, filterChanged, resetFilterChanged]);

  const createSortHandler = (property: keyof CustomerHistory) => (event: React.MouseEvent<unknown>) => {
    handleRequestSort(event, property);
  };

  const handleRequestSort = (event: React.MouseEvent<unknown>, property: keyof CustomerHistory) => {
    const isAsc = orderBy === property && sortOrder === 'asc';
    setSortOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    fireReload();
  };

  /*
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    fireReload();
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    fireReload();
  };
*/



  return (
    /*{
    <Grid container spacing={3} sx={{ overflowX: 'auto', marginTop: {xs: '1rem', sm: '1rem', md: '2rem', lg: '2rem'} }}>
    }
  */
    <Grid container spacing={3} sx={{ overflowX: 'auto', marginTop: { md: '2rem', lg: '2rem' } }}>
      <Snackbar open={error !== undefined} autoHideDuration={5000} onClose={() => resetError()}>
        <Alert onClose={() => resetError()} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
      <Grid item xs={12}>
        <Box sx={{ margin: '8px 0' }}>

          {loading && <Grid item xs={12} className="center">
            <CircularProgress /> Lade...
          </Grid>
          }
          {!loading && <Grid item xs={12} className="left">

            <Grid container spacing={3} sx={{ paddingBottom: '12px' }}>

              {/*
                            <Grid item xs={12} className="left"><Box component="span" sx={{fontWeight: 700, paddingLeft: '12px'}}>{dataCount} </Box>LinkedApps entsprechen Ihren Suchkriterien. </Grid>
                  */}
              <Grid item xs={12} className="left">
                <Typography variant='h1' sx={{ fontSize: { xs: '1.3rem', sm: '1.3rem', md: '2rem', lg: '2rem' } }}>Alle Dokumente</Typography>

              </Grid>
            </Grid>
            <Paper>
              <TableContainer>
                <Table aria-label="simple table" sx={{ tableLayout: 'fixed' }}>
                  <TableHead >

                    <TableRow sx={{ verticalAlign: 'top', display: { xs: 'table-row', sm: 'table-row', md: 'none', lg: 'none' } }} >
                      <TableCell key="sparte"
                        align={'left'}
                        padding='normal'
                        sx={{ fontWeight: 700, backgroundColor: '#A4C9DC', padding: '16px', cursor:'pointer', display:'flex', justifyContent:'space-between' }}
                        onClick={createSortHandler("sparte")}
                      >

                        <Box sx={{  width: '150px',alignContent:'flex-start' }}>
                            <b>Sparte</b>
                        </Box>
                        <TableSortLabel
                          active={true}
                          direction={orderBy === "sparte" ? sortOrder : 'asc'}
                          sx={{  width: '30px', alignContent:'flex-end' }}
                          >

                          <Box component="span" sx={visuallyHidden}>
                            {sortOrder === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </Box>

                        </TableSortLabel>

                      </TableCell>

                    </TableRow>
                    <TableRow sx={{ verticalAlign: 'top', display: { xs: 'none', sm: 'table-cell', md: 'table-row', lg: 'table-row' } }} >
                      {HeadCells.map((headCell) => (
                        <TableCell
                          key={headCell.id}
                          align={headCell.numeric ? 'right' : 'left'}

                          padding={headCell.disablePadding ? 'none' : 'normal'}
                          sx={{ fontWeight: 700, backgroundColor: '#A4C9DC', padding: '16px', display: { xs: headCell.visibleSm ? 'table-cell' : 'none', sm: headCell.visibleSm ? 'table-cell' : 'none', md: headCell.visibleMd ? 'table-cell' : 'none', lg: 'table-cell' }, width: headCell.width }}
                          sortDirection={orderBy === headCell.id ? sortOrder : false}
                        >
                          <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? sortOrder : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                            sx={{ display: { xs: headCell.visibleSm ? 'table-cell' : 'none', sm: headCell.visibleSm ? 'table-cell' : 'none', md: headCell.visibleMd ? 'table-cell' : 'none', lg: 'table-cell' } }}
                          >
                            <b>{headCell.label}</b>
                            {orderBy === headCell.id ? (
                              <Box component="span" sx={visuallyHidden}>
                                {sortOrder === 'desc' ? 'sorted descending' : 'sorted ascending'}
                              </Box>
                            ) : null}
                          </TableSortLabel>
                        </TableCell>
                      ))}
                      <TableCell
                        key="command"
                        align='right'
                        padding='none'
                        sx={{ fontWeight: 700, backgroundColor: '#A4C9DC', paddingTop: '4px', paddingBottom: '4px', display: { lg: 'table-cell' }, widht: '220px' }}

                      >

                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody sx={{
                    'tr:nth-of-type(even)': {
                      backgroundColor: "#DDEBF2"
                    }
                  }}>
                    {reportData && reportData.map((row) => (
                      <Reportingzeile row={row} key={row.linkId} tenant={tenant} />
                    ))
                    }
                  </TableBody>
                </Table>
              </TableContainer>
              {/* 
              <TablePagination
                labelRowsPerPage='Zeilen pro Seite'
                rowsPerPageOptions={[10, 25, 50, { value: -1, label: 'Alle' }]}
                component="div"
                count={dataCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
              */}
            </Paper>

          </Grid>
          }
        </Box>
      </Grid>
    </Grid>
  );
}
